import { errorMessage } from "../../utils/errorMessage";
import serviceList from ".././serviceList";
/**
 * @param value The value that is required
 * @returns return null if value is present; error message if value is blank
 */

function errorMapper(error: any) {
  if (error) {
    let errMsg = "";
    for (let i = 0; i < error.length; i++) {
      if (i === 0) errMsg = error[i].ErrorMessage;
      else if (!errMsg.includes(error[i].ErrorMessage)) {
        errMsg += `, ${error[i].ErrorMessage}`;
      }
    }
    return errMsg;
  }
}

function errorCodeMapper(error: any) {
  if (error) {
    let errMsg = "";
    for (let i = 0; i < error.length; i++) {
      if (i === 0) errMsg = error[i].ErrorCode;
      else if (!errMsg.includes(error[i].ErrorCode))
        errMsg += `, ${error[i].ErrorCode}`;
    }
    return errMsg;
  }
}

function msgOfErr(msgId: string) {
  return "";
  if (msgId) {
    let msg = `- ( ${msgId} )`;
    return msg;
  }
  return;
}

export default function requestMapper(response: any, serviceName: string): any {
  let result;
  switch (serviceName) {
    case serviceList.getCities:
      result = getCitiesMapping(response);
      return result;
    case serviceList.getEnumList:
      result = getEnumListMapping(response);
      return result;
    case serviceList.getEmployeeDetailsByPan:
      result = getEmployeeDetailsByPanMapping(response);
      return result;
    case serviceList.getPanUtiDetails:
      result = getPanUtiDetailsMapping(response);
      return result;
    case serviceList.getDocumentDetails:
      result = getDocumentDetailsMapping(response);
      return result;
    case serviceList.getArea:
      result = getAreaMapping(response);
      return result;
    case serviceList.getFullAddress:
      result = getFullAddressMapping(response);
      return result;
    case serviceList.getRelationshipData:
      result = getRelationshipDataMapping(response);
      return result;
    case serviceList.getKYCDetails:
      result = getKYCDetailsMapping(response);
      return result;
    case serviceList.saveKYCDetails:
      result = saveKYCDetailsMapping(response);
      return result;
    case serviceList.getStageCompletionStatus:
      result = getStageCompletionStatusMapping(response);
      return result;
    case serviceList.updateStageStatus:
      result = updateStatusMapping(response);
      return result;
    case serviceList.getCacheData:
      result = getCacheDataMapping(response);
      return result;
    case serviceList.checkClientProfilingData:
      result = checkClientProfilingDataMapping(response);
      return result;
    case serviceList.getClientProfilingQuestion:
      result = getClientProfilingQuestionMapping(response);
      return result;
    case serviceList.saveClientProfilingQuestion:
      result = saveClientProfilingQuestionMapping(response);
      return result;
    case serviceList.getClientProfilingDetails:
      result = getClientProfilingDetailsMapping(response);
      return result;
    case serviceList.getOCRDocumentResponseData:
      result = getOCRDocumentResponseDataMapping(response);
      return result;
    case serviceList.getDistinctBankList:
      result = getDistinctBankListMapping(response);
      return result;
    case serviceList.getBankCities:
      result = getBankCitiesMapping(response);
      return result;
    case serviceList.getBankBranch:
      result = getBankBranchMapping(response);
      return result;
    case serviceList.getBankDetailsFromIfsc:
      result = getBankDetailsFromIfscMapping(response);
      return result;
    case serviceList.getBankDetails:
      result = getBankDetailsMapping(response);
      return result;
    case serviceList.saveBankDetails:
      result = saveBankDetailsMapping(response);
      return result;
    case serviceList.getExtractDocumentData:
      result = getExtractDocumentDataMapping(response);
      return result;
    case serviceList.uploadDocumentToS3:
      result = uploadDocumentToS3Mapping(response);
      return result;
    case serviceList.saveDocumentDetails:
      result = saveDocumentDetailsMapping(response);
      return result;
    case serviceList.saveRelationshipDetails:
      result = saveRelationshipDetailsMapping(response);
      return result;
    case serviceList.getBrokerage:
      result = getBrokerageMapping(response);
      return result;
    case serviceList.getBrokerageDetails:
      result = getBrokerageDetailsMapping(response);
      return result;
    case serviceList.saveBrokerageDetails:
      result = saveBrokerageDetailsMapping(response);
      return result;
    case serviceList.getBrokerageSegmentDetails:
      result = getBrokerageSegmentDetailsMapping(response);
      return result;
    case serviceList.saveBrokerageSegmentDetails:
      result = saveBrokerageSegmentDetailsMapping(response);
      return result;
    case serviceList.getBeneficiaryName:
      result = getBeneficiaryNameMapping(response);
      return result;
    case serviceList.downloadDocumentFromS3:
      result = downloadDocumentFromS3Mapping(response);
      return result;
    case serviceList.getOtp:
      result = getOtpMapping(response);
      return result;
    case serviceList.getOtpNew:
      result = getOtpNewMapping(response);
      return result;
    case serviceList.validateOtp:
      result = validateOtpMapping(response);
    case serviceList.validateOtpNew:
      result = validateOtpNewMapping(response);
      return result;
    case serviceList.getClientDetailsByPan:
      result = getClientDetailsByPanMapping(response);
      return result;
    case serviceList.getClientDataByPanOrLead:
      result = getClientDataByPanOrLeadMapping(response);
      return result;
    case serviceList.checkPanInSystem:
      result = checkPanInSystemMapping(response);
      return result;
    case serviceList.panLinkedWithAadhar:
      result = panLinkedWithAadharMapping(response);
      return result;
    case serviceList.saveIpverificationDetails:
      result = saveIpverificationDetailsMapping(response);
      return result;
    case serviceList.saveUploadedDocumentDetails:
      result = saveUploadedDocumentDetailsMapping(response);
      return result;
    case serviceList.margeMultipleImagestoPDF:
      result = margeMultipleImagestoPDFMapping(response);
      return result;
    case serviceList.getPichainBeneficiaryName:
      result = getPichainBeneficiaryNameMapping(response);
      return result;
    case serviceList.getCKYCDetails:
      result = getCKYCDetailsMapping(response);
      return result;
    case serviceList.savePanDobDetails:
      result = savePanDobDetailsMapping(response);
      return result;
    case serviceList.getKraDetails:
      result = getKraDetailsMapping(response);
      return result;
    case serviceList.redisDigilockerDoc:
      result = redisDigilockerDocMapping(response);
      return result;
    case serviceList.getEmployeeDetails:
      result = getEmployeeDetailsMapping(response);
      return result;
    case serviceList.searchLeadByName:
      result = searchLeadByNameMapping(response);
      return result;
    case serviceList.createLead:
      result = createLeadMapping(response);
      return result;
      case serviceList.getEmailCIBIL:
      result = getEmailCIBIL(response);
      return result; 
    case serviceList.fetchLeadInfo:
      result = fetchLeadInformation(response);
      return result;
    case serviceList.emailUpdate:
      result = emailUpdateResponse(response);
      return result;

    case serviceList.uploadIPVMerge:
      result = uploadIPVMergeMapping(response);
      return result;
    case serviceList.imagetoVideoIpv:
      result = imagetoVideoIpvMapping(response);
      return result;
    case serviceList.generateAccessTokenForDigilockerJavaMW:
      result = generateAccessTokenForDigilockerJavaMWMapping(response);
      return result;
    case serviceList.getDocListFromDigilocker:
      result = getDocListFromDigilockerMapping(response);
      return result;
    case serviceList.getSelectedDocument:
      result = getSelectedDocumentMapping(response);
      return result;
    case serviceList.selfieLink:
      result = selfieLinkMapping(response);
      return result;
    case serviceList.getEsignLink:
      result = getEsignLinkMapping(response);
      return result;
    case serviceList.getAMLDetails:
      result = getAMLDetailsMapping(response);
      return result;
    case serviceList.getEsignRMVerificationLink:
      result = getEsignRMVerificationLinkMapping(response);
      return result;
    case serviceList.getRMAssitedEsignLink:
      result = getRMAssitedEsignLinkMapping(response);
      return result;
    case serviceList.updateUtmInfo:
      result = updateUtmInfoMapping(response);
      return result;
    case serviceList.getAccountcodeData:
      result = getAccountcodeDataMapping(response);
      return result;
    case serviceList.createApplicationTicket:
      result = createApplicationTicketMapping(response);
      return result;
    case serviceList.whatsUpAppInitiateCommunication:
      result = whatsUpAppInitiateCommunicationMapping(response);
      return result;
    case serviceList.whatsUpAppConsent:
      result = whatsUpAppConsentMapping(response);
      return result;
    case serviceList.generateKYCPdf:
      result = generateKYCPdfMapping(response);
      return result;
    case serviceList.getIPVOTP:
      result = getIPVOTPMapping(response);
      return result;
    case serviceList.ErrorBank:
      result = getErrorBank(response);
    case serviceList.getDocumentAutoQcDetails:
      result = getDocumentAutoQcDetailsMapping(response);
      return result;
    case serviceList.saveAddressDetails:
      result = saveAddressDetailsMapping(response);
      return result;
    case serviceList.getCityByPincode:
      result = getCityByPincodeMapping(response);
      return result;
    case serviceList.verifyDocumentData:
      result = verifyDocumentDataMapping(response);
      return result;
    case serviceList.getAddressDetails:
      result = getAddressDetailsMapping(response);
      return result;
    case serviceList.saveArea:
      result = saveAreaMapping(response);
      return result;

    case serviceList.checkPhotoLiveness:
      result = checkPhotoLivenessMapping(response);
      return result;
    case serviceList.checkLocation:
      result = checkLocationMapping(response);
      return result;
    case serviceList.updatePanAddharLinkStatus:
      result = updatePanAddharLinkStatusMapping(response);
      return result;
    case serviceList.createUCCRegCode:
      result = createUCCRegCodeMapping(response);
      return result;
    case serviceList.CheckRAAccount:
      result = checkRARelationShipMapper(response);
      return result;
    case serviceList.getKRADigiStatus:
      result = getKRADigiStatusMapping(response);
      return result;
    case serviceList.APanVerification:
      result = panVerificationMapper(response);
      return result;
    case serviceList.SaveDematDetailsRes:
      result = saveDematDetailsMapping(response);
      return result;
    case serviceList.DPverification:
      result = saveDpVerificationMapping(response);
      return result;
    case serviceList.getDPdetails:
      result = getDPDetailsInfo(response);
      return result;
    case serviceList.knowYourStatus:
      result = knowYourStatusMapping(response);
      return result;
    case serviceList.QcTaskCreation:
      result = QCTaskCreationMapping(response);
      return result;
    default:
      break;
    // code block
  }
}
function panVerificationMapper(res: any) {
  let result = {};
  if (res.RequestResult.Status.StatusCode == "1") {
    result = {
      status: true,
      msgID: res.RequestResult.RequestId,
      data: res.ContentData,
    };
  } else {
    result = {
      status: false,
      msgID: res.RequestResult.RequestId,
      data: {},
      error: `${errorMapper(res.RequestResult.Errors)}${msgOfErr(
        res.RequestResult.RequestId
      )}`,
    };
  }
  return result;
}
function getKRADigiStatusMapping(res: any) {
  let result = {};
  if (res.RequestResult.Status.StatusCode == "1") {
    result = {
      status: true,
      msgID: res.RequestResult.RequestId,
      data: res.ContentData,
    };
  } else {
    result = {
      status: false,
      msgID: res.RequestResult.RequestId,
      data: {},
      error: `${errorMapper(res.RequestResult.Errors)}${msgOfErr(
        res.RequestResult.RequestId
      )}`,
    };
  }
  return result;
}
function checkRARelationShipMapper(res: any) {
  let result = {};
  if (res.RequestResult.Status.StatusCode == "1") {
    result = {
      status: true,
      msgID: res.RequestResult.RequestId,
      data: res.ContentData,
    };
  } else {
    result = {
      status: false,
      msgID: res.RequestResult.RequestId,
      data: {},
      error: `${errorMapper(res.RequestResult.Errors)}${msgOfErr(
        res.RequestResult.RequestId
      )}`,
    };
  }
  return result;
}

function getCitiesMapping(res: any) {
  let result = {};
  if (res.RequestResult.Status.StatusCode == "1") {
    result = {
      status: true,
      msgID: res.RequestResult.RequestId,
      data: {
        city: res.ContentData,
      },
    };
  } else {
    result = {
      status: false,
      msgID: res.RequestResult.RequestId,
      data: {},
      error: `${errorMapper(res.RequestResult.Errors)}${msgOfErr(
        res.RequestResult.RequestId
      )}`,
    };
  }

  return result;
}

function getEnumListMapping(res: any) {
  let result = {};
  if (res.RequestResult.Status.StatusCode == "1") {
    result = {
      status: true,
      msgID: res.RequestResult.RequestId,
      data: {
        enumlist: res.ContentData,
      },
    };
  } else {
    result = {
      status: false,
      msgID: res.RequestResult.RequestId,
      data: {},
      error: `${errorMapper(res.RequestResult.Errors)}${msgOfErr(
        res.RequestResult.RequestId
      )}`,
    };
  }

  return result;
}

function getEmployeeDetailsByPanMapping(res: any) {
  let result = {};
  if (res.RequestResult.Status.StatusCode == "1") {
    console.log("res.ContentData====>", res);
    result = {
      status: true,
      msgID: res.RequestResult.RequestId,
      data: res.ContentData,
    };
  } else {
    result = {
      status: false,
      msgID: res.RequestResult.RequestId,
      data: {},
      error: `${errorMapper(res.RequestResult.Errors)}${msgOfErr(
        res.RequestResult.RequestId
      )}`,
    };
  }
  return result;
}
function getPanUtiDetailsMapping(res: any) {
  let result = {};
  if (res.RequestResult.Status.StatusCode == "1") {
    console.log("res.ContentData====>", res);
    result = {
      status: true,
      msgID: res.RequestResult.RequestId,
      data: res.ContentData,
    };
  } else {
    result = {
      status: false,
      msgID: res.RequestResult.RequestId,
      data: {},
      // error: errorMessage.newPanUtiError,
      error: `${errorMapper(res.RequestResult.Errors)}${msgOfErr(
        res.RequestResult.RequestId
      )}`,
    };
  }
  return result;
}

function getDocumentDetailsMapping(res: any) {
  let result = {};
  if (res.RequestResult.Status.StatusCode == "1") {
    result = {
      status: true,
      msgID: res.RequestResult.RequestId,
      data: res.ContentData,
    };
  } else {
    result = {
      status: false,
      msgID: res.RequestResult.RequestId,
      data: {},
      error: `${errorMapper(res.RequestResult.Errors)}${msgOfErr(
        res.RequestResult.RequestId
      )}`,
    };
  }

  return result;
}

function getAreaMapping(res: any) {
  let result = {};
  if (res.RequestResult.Status.StatusCode == "1") {
    result = {
      status: true,
      msgID: res.RequestResult.RequestId,
      data: {
        areas: res.ContentData,
      },
    };
  } else {
    result = {
      status: false,
      msgID: res.RequestResult.RequestId,
      data: {},
      error: `${errorMapper(res.RequestResult.Errors)}${msgOfErr(
        res.RequestResult.RequestId
      )}`,
    };
  }

  return result;
}

function getFullAddressMapping(res: any) {
  let result = {};
  if (res.RequestResult.Status.StatusCode == "1") {
    result = {
      status: true,
      msgID: res.RequestResult.RequestId,
      data: res.ContentData[0],
    };
  } else {
    result = {
      status: false,
      msgID: res.RequestResult.RequestId,
      data: {},
      error: `${errorMapper(res.RequestResult.Errors)}${msgOfErr(
        res.RequestResult.RequestId
      )}`,
    };
  }

  return result;
}

function getRelationshipDataMapping(res: any) {
  let result = {};
  if (res.RequestResult.Status.StatusCode == "1") {
    result = {
      status: true,
      msgID: res.RequestResult.RequestId,
      data: {
        emailMatchedList: res.ContentData.EmailMatchedList,
        mobileMatchedList: res.ContentData.MobileMatchedList,
        IsRelationshipFromIbeats: res.ContentData.IsRelationshipFromIbeats,
        IsSavedRelationship: res.ContentData.IsSavedRelationship,
        AvailableRelationshipTagEmail:
          res.ContentData.AvailableRelationshipTagEmail,
        AvailableRelationshipTagMobile:
          res.ContentData.AvailableRelationshipTagMobile,
      },
    };
  } else {
    result = {
      status: false,
      msgID: res.RequestResult.RequestId,
      data: {},
      error: `${errorMapper(res.RequestResult.Errors)}${msgOfErr(
        res.RequestResult.RequestId
      )}`,
    };
  }

  return result;
}

function getKYCDetailsMapping(res: any) {
  let result = {};
  if (res.RequestResult.Status.StatusCode == "1") {
    result = {
      status: true,
      msgID: res.RequestResult.RequestId,
      data: res.ContentData,
    };
  } else {
    result = {
      status: false,
      msgID: res.RequestResult.RequestId,
      data: {},
      error: `${errorMapper(res.RequestResult.Errors)}${msgOfErr(
        res.RequestResult.RequestId
      )}`,
    };
  }

  return result;
}

function saveKYCDetailsMapping(res: any) {
  let result = {};
  if (res.RequestResult.Status.StatusCode == "1") {
    result = {
      status: true,
      msgID: res.RequestResult.RequestId,
      data: res.ContentData,
    };
  } else {
    result = {
      status: false,
      msgID: res.RequestResult.RequestId,
      data: {},
      error: `${errorMapper(res.RequestResult.Errors)}${msgOfErr(
        res.RequestResult.RequestId
      )}`,
    };
  }

  return result;
}

function getStageCompletionStatusMapping(res: any) {
  let result = {};
  if (res.RequestResult.Status.StatusCode == "1") {
    result = {
      status: true,
      msgID: res.RequestResult.RequestId,
      data: res.ContentData,
    };
  } else {
    result = {
      status: false,
      msgID: res.RequestResult.RequestId,
      data: {},
      error: `${errorMapper(res.RequestResult.Errors)}${msgOfErr(
        res.RequestResult.RequestId
      )}`,
    };
  }

  return result;
}

function updateStatusMapping(res: any) {
  let result = {};
  if (res.RequestResult.Status.StatusCode == "1") {
    result = {
      status: true,
      msgID: res.RequestResult.RequestId,
      data: res.ContentData,
    };
  } else {
    result = {
      status: false,
      msgID: res.RequestResult.RequestId,
      data: {},
      error: `${errorMapper(res.RequestResult.Errors)}${msgOfErr(
        res.RequestResult.RequestId
      )}`,
    };
  }

  return result;
}
function getCacheDataMapping(res: any) {
  let result = {};
  if (res.RequestResult.Status.StatusCode == "1") {
    result = {
      status: true,
      msgID: res.RequestResult.RequestId,
      data: {
        ...res.ContentData,
        data: res.ContentData.Data,
      },
    };
  } else {
    result = {
      status: false,
      msgID: res.RequestResult.RequestId,
      data: {},
      error: `${errorMapper(res.RequestResult.Errors)}${msgOfErr(
        res.RequestResult.RequestId
      )}`,
    };
  }

  return result;
}

function checkClientProfilingDataMapping(res: any) {
  let result = {};
  if (res.RequestResult.Status.StatusCode == "1") {
    result = {
      status: true,
      msgID: res.RequestResult.RequestId,
      data: res.ContentData,
    };
  } else {
    result = {
      status: false,
      msgID: res.RequestResult.RequestId,
      data: {},
      error: `${errorMapper(res.RequestResult.Errors)}${msgOfErr(
        res.RequestResult.RequestId
      )}`,
    };
  }

  return result;
}

function getClientProfilingQuestionMapping(res: any) {
  let result = {};
  if (res.RequestResult.Status.StatusCode == "1") {
    result = {
      status: true,
      msgID: res.RequestResult.RequestId,
      data: res.ContentData,
    };
  } else {
    result = {
      status: false,
      msgID: res.RequestResult.RequestId,
      data: {},
      error: `${errorMapper(res.RequestResult.Errors)}${msgOfErr(
        res.RequestResult.RequestId
      )}`,
    };
  }

  return result;
}
function saveClientProfilingQuestionMapping(res: any) {
  let result = {};
  if (res.RequestResult.Status.StatusCode == "1") {
    result = {
      status: true,
      msgID: res.RequestResult.RequestId,
      data: res.ContentData,
    };
  } else {
    result = {
      status: false,
      msgID: res.RequestResult.RequestId,
      data: {},
      error: `${errorMapper(res.RequestResult.Errors)}${msgOfErr(
        res.RequestResult.RequestId
      )}`,
    };
  }

  return result;
}
function getClientProfilingDetailsMapping(res: any) {
  let result = {};
  if (res.RequestResult.Status.StatusCode == "1") {
    result = {
      status: true,
      msgID: res.RequestResult.RequestId,
      data: JSON.parse(res.ContentData).IsClientProfilingCompleted,
    };
  } else {
    result = {
      status: false,
      msgID: res.RequestResult.RequestId,
      data: {},
      error: `${errorMapper(res.RequestResult.Errors)}${msgOfErr(
        res.RequestResult.RequestId
      )}`,
    };
  }

  return result;
}
function getOCRDocumentResponseDataMapping(res: any) {
  let result = {};
  if (res.RequestResult.Status.StatusCode == "1") {
    result = {
      status: true,
      msgID: res.RequestResult.RequestId,
      data: res.ContentData !== null ? res.ContentData : "Record Not Found",
    };
  } else {
    result = {
      status: false,
      msgID: res.RequestResult.RequestId,
      data: {},
      error: `${errorMapper(res.RequestResult.Errors)}${msgOfErr(
        res.RequestResult.RequestId
      )}`,
    };
  }

  return result;
}
function getDistinctBankListMapping(res: any) {
  let result = {};
  if (res.RequestResult.Status.StatusCode == "1") {
    result = {
      status: true,
      msgID: res.RequestResult.RequestId,
      data: {
        banknames: res.ContentData,
      },
    };
  } else {
    result = {
      status: false,
      msgID: res.RequestResult.RequestId,
      data: {},
      error: `${errorMapper(res.RequestResult.Errors)}${msgOfErr(
        res.RequestResult.RequestId
      )}`,
    };
  }

  return result;
}
function getBankCitiesMapping(res: any) {
  let result = {};
  if (res.RequestResult.Status.StatusCode == "1") {
    result = {
      status: true,
      msgID: res.RequestResult.RequestId,
      data: {
        bankcities: res.ContentData,
      },
    };
  } else {
    result = {
      status: false,
      msgID: res.RequestResult.RequestId,
      data: {},
      error: `${errorMapper(res.RequestResult.Errors)}${msgOfErr(
        res.RequestResult.RequestId
      )}`,
    };
  }

  return result;
}
function getBankBranchMapping(res: any) {
  let result = {};
  if (res.RequestResult.Status.StatusCode == "1") {
    result = {
      status: true,
      msgID: res.RequestResult.RequestId,
      data: {
        bankbranches: res.ContentData,
      },
    };
  } else {
    result = {
      status: false,
      msgID: res.RequestResult.RequestId,
      data: {},
      error: `${errorMapper(res.RequestResult.Errors)}${msgOfErr(
        res.RequestResult.RequestId
      )}`,
    };
  }

  return result;
}
function getBankDetailsFromIfscMapping(res: any) {
  let result = {};
  if (res.RequestResult.Status.StatusCode == "1") {
    result = {
      status: true,
      msgID: res.RequestResult.RequestId,
      data: {
        ecoIBeatsBank: res.ContentData,
      },
    };
  } else {
    result = {
      status: false,
      msgID: res.RequestResult.RequestId,
      data: res,
      error: `${errorMapper(res.RequestResult.Errors)}${msgOfErr(
        res.RequestResult.RequestId
      )}`,
    };
  }

  return result;
}
function getBankDetailsMapping(res: any) {
  let result = {};
  if (res.RequestResult.Status.StatusCode == "1") {
    result = {
      status: true,
      msgID: res.RequestResult.RequestId,
      data: res.ContentData !== null ? res.ContentData : "Record Not Found",
      statusMessage: res.RequestResult.Status,
    };
  } else {
    result = {
      status: false,
      statusMessage: res.RequestResult.Status,
      msgID: res.RequestResult.RequestId,
      data: {},
      error: `${errorMapper(res.RequestResult.Errors)}${msgOfErr(
        res.RequestResult.RequestId
      )}`,
    };
  }

  return result;
}

function saveBankDetailsMapping(res: any) {
  let result = {};
  if (res.RequestResult.Status.StatusCode == "1") {
    result = {
      status: true,
      msgID: res.RequestResult.RequestId,
      data: res.ContentData,
    };
  } else {
    result = {
      status: false,
      msgID: res.RequestResult.RequestId,
      data: {},
      error: `${errorMapper(res.RequestResult.Errors)}${msgOfErr(
        res.RequestResult.RequestId
      )}`,
    };
  }

  return result;
}

function getExtractDocumentDataMapping(res: any) {
  let result = {};
  if (res.RequestResult.Status.StatusCode == "1") {
    result = {
      status: true,
      msgID: res.RequestResult.RequestId,
      data: res.ContentData,
    };
  } else {
    result = {
      status: false,
      msgID: res.RequestResult.RequestId,
      data: res.ContentData ? res.ContentData : {},
      error: `${errorMapper(res.RequestResult.Errors)}${msgOfErr(
        res.RequestResult.RequestId
      )}`,
    };
  }

  return result;
}

function uploadDocumentToS3Mapping(res: any) {
  let result = {};
  console.log("uploadDocumentToS3Mapping", res);
  if (res.RequestResult.Status.StatusCode == "1") {
    result = {
      status: true,
      msgID: res.RequestResult.RequestId,
      data: res.ContentData,
    };
  } else {
    result = {
      status: false,
      msgID: res.RequestResult.RequestId,
      data: {},
      errorCode: `${errorCodeMapper(res.RequestResult.Errors)}`,
      error: `${errorMapper(res.RequestResult.Errors)}${msgOfErr(
        res.RequestResult.RequestId
      )}`,
    };
  }

  return result;
}
function saveDocumentDetailsMapping(res: any) {
  let result = {};
  if (res.RequestResult.Status.StatusCode == "1") {
    result = {
      status: true,
      msgID: res.RequestResult.RequestId,
      data: res.ContentData,
    };
  } else {
    result = {
      status: false,
      msgID: res.RequestResult.RequestId,
      data: {},
      error: `${errorMapper(res.RequestResult.Errors)}${msgOfErr(
        res.RequestResult.RequestId
      )}`,
    };
  }

  return result;
}
function saveRelationshipDetailsMapping(res: any) {
  let result = {};
  if (res.RequestResult.Status.StatusCode == "1") {
    result = {
      status: true,
      msgID: res.RequestResult.RequestId,
      data: res.ContentData,
    };
  } else {
    result = {
      status: false,
      msgID: res.RequestResult.RequestId,
      data: {},
      error: `${errorMapper(res.RequestResult.Errors)}${msgOfErr(
        res.RequestResult.RequestId
      )}`,
    };
  }

  return result;
}
function getBrokerageMapping(res: any) {
  let result = {};
  if (res.RequestResult.Status.StatusCode == "1") {
    result = {
      status: true,
      msgID: res.RequestResult.RequestId,
      data: res.ContentData[0],
    };
  } else {
    result = {
      status: false,
      msgID: res.RequestResult.RequestId,
      data: {},
      error: `${errorMapper(res.RequestResult.Errors)}${msgOfErr(
        res.RequestResult.RequestId
      )}`,
    };
  }

  return result;
}
function getDPDetailsInfo(res: any) {
  let result = {};
  if (res.RequestResult.Status.StatusCode == "1") {
    result = {
      status: true,
      msgID: res.RequestResult.RequestId,
      data: res.ContentData,
    };
  } else {
    result = {
      status: false,
      msgID: res.RequestResult.RequestId,
      data: {},
      error: `${errorMapper(res.RequestResult.Errors)}${msgOfErr(
        res.RequestResult.RequestId
      )}`,
    };
  }

  return result;
}
function getBrokerageDetailsMapping(res: any) {
  let result = {};
  if (res.RequestResult.Status.StatusCode == "1") {
    result = {
      status: true,
      msgID: res.RequestResult.RequestId,
      data: {
        brokerageDetails: res.ContentData,
      },
    };
  } else {
    result = {
      status: false,
      msgID: res.RequestResult.RequestId,
      data: {},
      error: `${errorMapper(res.RequestResult.Errors)}${msgOfErr(
        res.RequestResult.RequestId
      )}`,
    };
  }

  return result;

}
function saveDematDetailsMapping(res: any) {
  let result = {};
  if (res.RequestResult.Status.StatusCode == "1") {
    result = {
      status: true,
      msgID: res.RequestResult.RequestId,
      data: res.ContentData,
    };
  } else {
    result = {
      status: false,
      msgID: res.RequestResult.RequestId,
      data: {},
      error: `${errorMapper(res.RequestResult.Errors)}${msgOfErr(
        res.RequestResult.RequestId
      )}`,
    };
  }
  return result;
}
function QCTaskCreationMapping(res: any) {
  let result = {};
  if (res.RequestResult.Status.StatusCode == "1") {
    result = {
      status: true,
      msgID: res.RequestResult.RequestId,
      data: res.ContentData,
    };
  } else {
    result = {
      status: false,
      msgID: res.RequestResult.RequestId,
      data: {},
      error: `${errorMapper(res.RequestResult.Errors)}${msgOfErr(
        res.RequestResult.RequestId
      )}`,
    };
  }
  return result;
}
function saveDpVerificationMapping(res: any) {
  let result = {};
  if (res.RequestResult.Status.StatusCode == "1") {
    result = {
      status: true,
      msgID: res.RequestResult.RequestId,
      data: res.ContentData,
    };
  } else {
    result = {
      status: false,
      msgID: res.RequestResult.RequestId,
      data: {},
      error: `${errorMapper(res.RequestResult.Errors)}${msgOfErr(
        res.RequestResult.RequestId
      )}`,
    };
  }

  return result;
}

function saveBrokerageDetailsMapping(res: any) {
  let result = {};
  if (res.RequestResult.Status.StatusCode == "1") {
    result = {
      status: true,
      msgID: res.RequestResult.RequestId,
      data: res.ContentData,
    };
  } else {
    result = {
      status: false,
      msgID: res.RequestResult.RequestId,
      data: {},
      error: `${errorMapper(res.RequestResult.Errors)}${msgOfErr(
        res.RequestResult.RequestId
      )}`,
    };
  }

  return result;
}
function getBrokerageSegmentDetailsMapping(res: any) {
  let result = {};
  if (res.RequestResult.Status.StatusCode == "1") {
    result = {
      status: true,
      msgID: res.RequestResult.RequestId,
      data: {
        dbelist: res.ContentData,
      },
    };
  } else {
    result = {
      status: false,
      msgID: res.RequestResult.RequestId,
      data: {},
      error: `${errorMapper(res.RequestResult.Errors)}${msgOfErr(
        res.RequestResult.RequestId
      )}`,
    };
  }

  return result;
}
function saveBrokerageSegmentDetailsMapping(res: any) {
  let result = {};
  if (res.RequestResult.Status.StatusCode == "1") {
    result = {
      status: true,
      msgID: res.RequestResult.RequestId,
      data: res.ContentData,
    };
  } else {
    result = {
      status: false,
      msgID: res.RequestResult.RequestId,
      data: {},
      error: `${errorMapper(res.RequestResult.Errors)}${msgOfErr(
        res.RequestResult.RequestId
      )}`,
    };
  }

  return result;
}
function getBeneficiaryNameMapping(res: any) {
  let result = {};
  if (res.RequestResult.Status.StatusCode == "1") {
    result = {
      status: true,
      msgID: res.RequestResult.RequestId,
      data: res.ContentData,
    };
  } else {
    result = {
      status: false,
      msgID: res.RequestResult.RequestId,
      data: {},
      error: `${errorMapper(res.RequestResult.Errors)}${msgOfErr(
        res.RequestResult.RequestId
      )}`,
    };
  }

  return result;
}
function downloadDocumentFromS3Mapping(res: any) {
  let result = {};
  if (res.RequestResult.Status.StatusCode == "1") {
    result = {
      status: true,
      msgID: res.RequestResult.RequestId,
      data: res.ContentData,
    };
  } else {
    result = {
      status: false,
      msgID: res.RequestResult.RequestId,
      data: {},
      error: `${errorMapper(res.RequestResult.Errors)}${msgOfErr(
        res.RequestResult.RequestId
      )}`,
    };
  }

  return result;
}

function getOtpMapping(res: any) {
  let result = {};
  if (res.RequestResult.Status.StatusCode == "1") {
    result = {
      status: true,
      msgID: res.RequestResult.RequestId,
      data: res.ContentData,
    };
  } else {
    result = {
      status: false,
      msgID: res.RequestResult.RequestId,
      data: {},
      error: `${errorMapper(res.RequestResult.Errors)}${msgOfErr(
        res.RequestResult.RequestId
      )}`,
    };
  }

  return result;
}
function getOtpNewMapping(res: any) {
  let result = {};
  if (res.RequestResult.Status.StatusCode == "1") {
    result = {
      status: true,
      msgID: res.RequestResult.RequestId,
      data: res.ContentData,
    };
  } else {
    result = {
      status: false,
      msgID: res.RequestResult.RequestId,
      data: {},
      error: `${errorMapper(res.RequestResult.Errors)}${msgOfErr(
        res.RequestResult.RequestId
      )}`,
    };
  }

  return result;
}
function validateOtpMapping(res: any) {
  let result = {};
  if (res.RequestResult.Status.StatusCode == "1") {
    result = {
      status: true,
      msgID: res.RequestResult.RequestId,
      data: res.ContentData,
    };
  } else {
    result = {
      status: false,
      msgID: res.RequestResult.RequestId,
      data: {},
      error: `${errorMapper(res.RequestResult.Errors)}${msgOfErr(
        res.RequestResult.RequestId
      )}`,
    };
  }
  return result;
}
function validateOtpNewMapping(res: any) {
  let result = {};
  if (res.RequestResult.Status.StatusCode == "1") {
    result = {
      status: true,
      msgID: res.RequestResult.RequestId,
      data: res.ContentData,
    };
  } else {
    result = {
      status: false,
      msgID: res.RequestResult.RequestId,
      data: {},
      error: `${errorMapper(res.RequestResult.Errors)}${msgOfErr(
        res.RequestResult.RequestId
      )}`,
    };
  }
  return result;
}
function getClientDetailsByPanMapping(res: any) {
  let result = {};
  if (res.RequestResult.Status.StatusCode == "1") {
    result = {
      status: true,
      msgID: res.RequestResult.RequestId,
      data: res.ContentData != null ? res.ContentData : "Records Not Found",
    };
  } else {
    result = {
      status: false,
      msgID: res.RequestResult.RequestId,
      data: {},
      error: `${errorMapper(res.RequestResult.Errors)}${msgOfErr(
        res.RequestResult.RequestId
      )}`,
    };
  }
  return result;
}
function knowYourStatusMapping(res: any) {
  let result = {};
  if (res.RequestResult.Status.StatusCode == "1") {
    let resData = res.ContentData;
    if (res.ContentData == null) {
      resData = "Records Not Found";
    } else {
      if (res.ContentData?.length > 0) {
        if (res.ContentData?.length == 1) {
          resData = res?.ContentData[0];
        } else if (res.ContentData?.length > 1) {
          resData = res?.ContentData;
        }
      }
    }
    result = {
      status: true,
      msgID: res.RequestResult.RequestId,
      data: res.ContentData != null ? res.ContentData : "Records Not Found",
    };
  } else {
    result = {
      status: false,
      msgID: res.RequestResult.RequestId,
      data: {},
      error: `${errorMapper(res.RequestResult.Errors)}${msgOfErr(
        res.RequestResult.RequestId
      )}`,
    };
  }
  return result;
}
function getClientDataByPanOrLeadMapping(res: any) {
  let result = {};
  if (res.RequestResult.Status.StatusCode == "1") {
    result = {
      status: true,
      msgID: res.RequestResult.RequestId,
      data: res.ContentData,
    };
  } else {
    result = {
      status: false,
      msgID: res.RequestResult.RequestId,
      data: {},
      error: `${errorMapper(res.RequestResult.Errors)}${msgOfErr(
        res.RequestResult.RequestId
      )}`,
    };
  }
  return result;
}

function checkPanInSystemMapping(res: any) {
  let result = {};
  if (res.RequestResult.Status.StatusCode == "1") {
    result = {
      status: true,
      msgID: res.RequestResult.RequestId,
      data: res.ContentData,
    };
  } else {
    result = {
      status: false,
      msgID: res.RequestResult.RequestId,
      data: {},
      error: `${errorMapper(res.RequestResult.Errors)}${msgOfErr(
        res.RequestResult.RequestId
      )}`,
    };
  }

  return result;
}
function panLinkedWithAadharMapping(res: any) {
  let result = {};
  if (res.RequestResult.Status.StatusCode == "1") {
    result = {
      status: true,
      msgID: res.RequestResult.RequestId,
      data: res.ContentData,
    };
  } else {
    result = {
      status: false,
      msgID: res.RequestResult.RequestId,
      data: {},
      error: `${errorMapper(res.RequestResult.Errors)}${msgOfErr(
        res.RequestResult.RequestId
      )}`,
    };
  }

  return result;
}

function saveIpverificationDetailsMapping(res: any) {
  let result = {};
  if (res.RequestResult.Status.StatusCode == "1") {
    result = {
      status: true,
      msgID: res.RequestResult.RequestId,
      data: res.ContentData,
    };
  } else {
    result = {
      status: false,
      msgID: res.RequestResult.RequestId,
      data: {},
      error: `${errorMapper(res.RequestResult.Errors)}${msgOfErr(
        res.RequestResult.RequestId
      )}`,
    };
  }

  return result;
}
function saveUploadedDocumentDetailsMapping(res: any) {
  let result = {};
  if (res.RequestResult.Status.StatusCode == "1") {
    result = {
      status: true,
      msgID: res.RequestResult.RequestId,
      data: res.ContentData,
    };
  } else {
    result = {
      status: false,
      msgID: res.RequestResult.RequestId,
      data: {},
      error: `${errorMapper(res.RequestResult.Errors)}${msgOfErr(
        res.RequestResult.RequestId
      )}`,
    };
  }

  return result;
}

function margeMultipleImagestoPDFMapping(res: any) {
  let result = {};
  if (res.RequestResult.Status.StatusCode == "1") {
    result = {
      status: true,
      msgID: res.RequestResult.RequestId,
      data: res.ContentData,
    };
  } else {
    result = {
      status: false,
      msgID: res.RequestResult.RequestId,
      data: {},
      error: `${errorMapper(res.RequestResult.Errors)}${msgOfErr(
        res.RequestResult.RequestId
      )}`,
    };
  }

  return result;
}
function getPichainBeneficiaryNameMapping(res: any) {
  let result = {};
  if (res.RequestResult.Status.StatusCode == "1") {
    result = {
      status: true,
      msgID: res.RequestResult.RequestId,
      data: res.ContentData,
    };
  } else {
    result = {
      status: false,
      msgID: res.RequestResult.RequestId,
      data: {},
      error: `${errorMapper(res.RequestResult.Errors)}${msgOfErr(
        res.RequestResult.RequestId
      )}`,
    };
  }

  return result;
}
function getCKYCDetailsMapping(res: any) {
  let result = {};
  if (res.RequestResult.Status.StatusCode == "1") {
    result = {
      status: true,
      msgID: res.RequestResult.RequestId,
      data: res.ContentData,
    };
  } else {
    result = {
      status: false,
      msgID: res.RequestResult.RequestId,
      data: {},
      error: errorMessage.newCkycError,
      errMsg: `${errorMapper(res.RequestResult.Errors)}${msgOfErr(
        res.RequestResult.RequestId
      )}`,
    };
  }

  return result;
}
function savePanDobDetailsMapping(res: any) {
  console.log("savePanDobDetailsMapping", res);
  let result = {};
  if (res.RequestResult.Status.StatusCode == "1") {
    result = {
      status: true,
      msgID: res.RequestResult.RequestId,
      data: res.ContentData,
    };
    console.log(result);
  } else {
    result = {
      status: false,
      msgID: res.RequestResult.RequestId,
      data: {},
      error: `${errorMapper(res.RequestResult.Errors)}${msgOfErr(
        res.RequestResult.RequestId
      )}`,
    };
  }

  return result;
}

function getKraDetailsMapping(res: any) {
  let result = {};
  if (res.RequestResult.Status.StatusCode == "1") {
    result = {
      status: true,
      msgID: res.RequestResult.RequestId,
      data: res.ContentData,
    };
  } else {
    result = {
      status: false,
      msgID: res.RequestResult.RequestId,
      data: {},
      error: errorMessage.newKraError,
      errMsg: `${errorMapper(res.RequestResult.Errors)}${msgOfErr(
        res.RequestResult.RequestId
      )}`,
    };
  }

  return result;
}

function redisDigilockerDocMapping(res: any) {
  let result = {};
  if (res.RequestResult.Status.StatusCode == "1") {
    result = {
      status: true,
      msgID: res.RequestResult.RequestId,
      data: res.ContentData,
    };
  } else {
    result = {
      status: false,
      msgID: res.RequestResult.RequestId,
      data: {},
      error: `${errorMapper(res.RequestResult.Errors)}${msgOfErr(
        res.RequestResult.RequestId
      )}`,
    };
  }

  return result;
}

function getEmployeeDetailsMapping(res: any) {
  let result = {};
  if (res.RequestResult.Status.StatusCode == "1") {
    result = {
      status: true,
      msgID: res.RequestResult.RequestId,
      data: res.ContentData,
    };
  } else {
    result = {
      status: false,
      msgID: res.RequestResult.RequestId,
      data: {},
      error: `${errorMapper(res.RequestResult.Errors)}${msgOfErr(
        res.RequestResult.RequestId
      )}`,
    };
  }

  return result;
}

function getAccountcodeDataMapping(res: any) {
  let result = {};
  if (res.RequestResult.Status.StatusCode == "1") {
    result = {
      status: true,
      msgID: res.RequestResult.RequestId,
      data: res.ContentData,
    };
  } else {
    result = {
      status: false,
      msgID: res.RequestResult.RequestId,
      data: {},
      error: `${errorMapper(res.RequestResult.Errors)}${msgOfErr(
        res.RequestResult.RequestId
      )}`,
    };
  }

  return result;
}

function searchLeadByNameMapping(res: any) {
  let result = {};
  if (res.RequestResult.Status.StatusCode == "1") {
    result = {
      status: true,
      msgID: res.RequestResult.RequestId,
      data: res.ContentData,
    };
  } else {
    result = {
      status: false,
      msgID: res.RequestResult.RequestId,
      data: {},
      existedFieldDetails: {
        mob: res?.RequestResult?.Errors?.find((x: any) => x.Field == "Mobileno")
          ? true
          : false,
        email: res?.RequestResult?.Errors.find((x: any) => x.Field == "Email")
          ? true
          : false,
      },
      error: `${errorMapper(res.RequestResult.Errors)}${msgOfErr(
        res.RequestResult.RequestId
      )}`,
    };
  }

  return result;
}

function createLeadMapping(res: any) {
  let result = {};
  if (res.RequestResult.Status.StatusCode == "1") {
    result = {
      status: true,
      msgID: res.RequestResult.RequestId,
      data: res.ContentData,
    };
  } else {
    result = {
      status: false,
      msgID: res.RequestResult.RequestId,
      data: {},
      error: `${errorMapper(res.RequestResult.Errors)}${msgOfErr(
        res.RequestResult.RequestId
      )}`,
    };
  }

  return result;
}
function getEmailCIBIL(res: any) {
  let result = {};
  if (res.RequestResult.Status.StatusCode == "1") {
    result = {
      status: true,
      msgID: res.RequestResult.RequestId,
      data: res.ContentData,
    };
  } else {
    result = {
      status: false,
      msgID: res.RequestResult.RequestId,
      data: {},
      error: `${errorMapper(res.RequestResult.Errors)}${msgOfErr(
        res.RequestResult.RequestId
      )}`,
    };
  }

  return result;
}
function fetchLeadInformation(res: any) {
  let result = {};
  if (res.RequestResult.Status.StatusCode == "1") {
    result = {
      status: true,
      msgID: res.RequestResult.RequestId,
      data: res.ContentData,
    };
  } else {
    result = {
      status: false,
      msgID: res.RequestResult.RequestId,
      data: {},
      error: `${errorMapper(res.RequestResult.Errors)}${msgOfErr(
        res.RequestResult.RequestId
      )}`,
    };
  }

  return result;
}
function emailUpdateResponse(res: any) {
  let result = {};
  if (res.RequestResult.Status.StatusCode == "1") {
    result = {
      status: true,
      msgID: res.RequestResult.RequestId,
      data: res.ContentData,
    };
  } else {
    result = {
      status: false,
      msgID: res.RequestResult.RequestId,
      data: {},
      error: `${errorMapper(res.RequestResult.Errors)}${msgOfErr(
        res.RequestResult.RequestId
      )}`,
    };
  }

  return result;
}

function uploadIPVMergeMapping(res: any) {
  let result = {};
  if (res.RequestResult.Status.StatusCode == "1") {
    result = {
      status: true,
      msgID: res.RequestResult.RequestId,
      data: res.ContentData,
    };
  } else {
    result = {
      status: false,
      msgID: res.RequestResult.RequestId,
      data: {},
      error: `${errorMapper(res.RequestResult.Errors)}${msgOfErr(
        res.RequestResult.RequestId
      )}`,
    };
  }

  return result;
}

function imagetoVideoIpvMapping(res: any) {
  let result = {};
  if (res.RequestResult.Status.StatusCode == "1") {
    result = {
      status: true,
      msgID: res.RequestResult.RequestId,
      data: res.ContentData,
    };
  } else {
    result = {
      status: false,
      msgID: res.RequestResult.RequestId,
      data: {},
      error: `${errorMapper(res.RequestResult.Errors)}${msgOfErr(
        res.RequestResult.RequestId
      )}`,
    };
  }

  return result;
}

function generateAccessTokenForDigilockerJavaMWMapping(res: any) {
  let result = {};
  if (res.RequestResult.Status.StatusCode == "1") {
    result = {
      status: true,
      msgID: res.RequestResult.RequestId,
      data: res.ContentData,
    };
  } else {
    result = {
      status: false,
      msgID: res.RequestResult.RequestId,
      data: {},
      error: errorMessage.newDigilockerError,
      errMsg: `${errorMapper(res.RequestResult.Errors)}${msgOfErr(
        res.RequestResult.RequestId
      )}`,
    };
  }

  return result;
}
function getDocListFromDigilockerMapping(res: any) {
  let result = {};
  if (res.RequestResult.Status.StatusCode == "1") {
    result = {
      status: true,
      msgID: res.RequestResult.RequestId,
      data: res.ContentData,
    };
  } else {
    result = {
      status: false,
      msgID: res.RequestResult.RequestId,
      data: {},
      error: errorMessage.newDigilockerError,
      errMsg: `${errorMapper(res.RequestResult.Errors)}${msgOfErr(
        res.RequestResult.RequestId
      )}`,
    };
  }

  return result;
}
function getSelectedDocumentMapping(res: any) {
  let result = {};
  if (res.RequestResult.Status.StatusCode == "1") {
    result = {
      status: true,
      msgID: res.RequestResult.RequestId,
      data: res.ContentData,
    };
  } else {
    result = {
      status: false,
      msgID: res.RequestResult.RequestId,
      data: {},
      // error: errorMessage.newDigilockerError,
      error: `${errorMapper(res.RequestResult.Errors)}${msgOfErr(
        res.RequestResult.RequestId
      )}`,
    };
  }

  return result;
}
function selfieLinkMapping(res: any) {
  let result = {};
  if (res.RequestResult.Status.StatusCode == "1") {
    result = {
      status: true,
      msgID: res.RequestResult.RequestId,
      data: res.ContentData,
    };
  } else {
    result = {
      status: false,
      msgID: res.RequestResult.RequestId,
      data: {},
      error: `${errorMapper(res.RequestResult.Errors)}${msgOfErr(
        res.RequestResult.RequestId
      )}`,
    };
  }

  return result;
}
function getRMAssitedEsignLinkMapping(res: any) {
  console.log(res, "PPPP");
  let result = {};
  if (res.RequestResult.Status.StatusCode == "1") {
    result = {
      status: true,
      msgID: res.RequestResult.RequestId,
      data: res.ContentData,
    };
  } else {
    result = {
      status: false,
      msgID: res.RequestResult.RequestId,
      data: {},
      // error: errorMessage.newEsignError,
      error: `${errorMapper(res.RequestResult.Errors)}${msgOfErr(
        res.RequestResult.RequestId
      )}`,
    };
  }

  return result;
}

function getEsignLinkMapping(res: any) {
  console.log(res, "PPPP");
  let result = {};
  if (res.RequestResult.Status.StatusCode == "1") {
    if (!!res?.ContentData?.Message && !!res?.ContentData?.Message?.StatusMsg && res?.ContentData?.Message?.StatusMsg?.toLowerCase() == "FAILURE"?.toLowerCase()) {
      result = {
        status: false,
        msgID: res.RequestResult.RequestId,
        data: {},
        // error: errorMessage.newEsignError,
        error: `${errorMapper(res.RequestResult.Errors)}${msgOfErr(
          res.RequestResult.RequestId
        )}`,
      };
    } else {
      result = {
        status: true,
        msgID: res.RequestResult.RequestId,
        data: res.ContentData,
      };
    }
  } else {
    result = {
      status: false,
      msgID: res.RequestResult.RequestId,
      data: {},
      // error: errorMessage.newEsignError,
      error: `${errorMapper(res.RequestResult.Errors)}${msgOfErr(
        res.RequestResult.RequestId
      )}`,
    };
  }

  return result;
}
function getAMLDetailsMapping(res: any) {
  console.log(res, "PPPP");
  let result = {};
  if (res.RequestResult.Status.StatusCode == "1") {
    if (!!res?.ContentData?.Message && !!res?.ContentData?.Message?.StatusMsg && res?.ContentData?.Message?.StatusMsg?.toLowerCase() == "FAILURE"?.toLowerCase()) {
      result = {
        status: false,
        msgID: res.RequestResult.RequestId,
        data: {},
        // error: errorMessage.newEsignError,
        error: `${errorMapper(res.RequestResult.Errors)}${msgOfErr(
          res.RequestResult.RequestId
        )}`,
      };
    } else {
      result = {
        status: true,
        msgID: res.RequestResult.RequestId,
        data: res.ContentData,
      };
    }
  } else {
    result = {
      status: false,
      msgID: res.RequestResult.RequestId,
      data: {},
      // error: errorMessage.newEsignError,
      error: `${errorMapper(res.RequestResult.Errors)}${msgOfErr(
        res.RequestResult.RequestId
      )}`,
    };
  }

  return result;
}
function getEsignRMVerificationLinkMapping(res: any) {
  console.log(res, "PPPP");
  let result = {};
  if (res.RequestResult.Status.StatusCode == "1") {
    result = {
      status: true,
      msgID: res.RequestResult.RequestId,
      data: res.ContentData,
    };

  } else {
    result = {
      status: false,
      msgID: res.RequestResult.RequestId,
      data: {},
      // error: errorMessage.newEsignError,
      error: `${errorMapper(res.RequestResult.Errors)}${msgOfErr(
        res.RequestResult.RequestId
      )}`,
    };
  }

  return result;
}

function updateUtmInfoMapping(res: any) {
  let result = {};
  if (res.RequestResult.Status.StatusCode == "1") {
    result = {
      status: true,
      msgID: res.RequestResult.RequestId,
      data: res.ContentData,
    };
  } else {
    result = {
      status: false,
      msgID: res.RequestResult.RequestId,
      data: {},
      error: `${errorMapper(res.RequestResult.Errors)}${msgOfErr(
        res.RequestResult.RequestId
      )}`,
    };
  }

  return result;
}

function createApplicationTicketMapping(res: any) {
  let result = {};
  if (res.RequestResult.Status.StatusCode == "1") {
    result = {
      status: true,
      msgID: res.RequestResult.RequestId,
      data: res.ContentData,
    };
  } else {
    result = {
      status: false,
      msgID: res.RequestResult.RequestId,
      data: {},
      error: `${errorMapper(res.RequestResult.Errors)}${msgOfErr(
        res.RequestResult.RequestId
      )}`,
    };
  }

  return result;
}
function whatsUpAppInitiateCommunicationMapping(res: any) {
  let result = {};
  if (res.RequestResult.Status.StatusCode == "1") {
    result = {
      status: true,
      msgID: res.RequestResult.RequestId,
      data: res.ContentData,
    };
  } else {
    result = {
      status: false,
      msgID: res.RequestResult.RequestId,
      data: {},
      error: `${errorMapper(res.RequestResult.Errors)}${msgOfErr(
        res.RequestResult.RequestId
      )}`,
    };
  }

  return result;
}
function whatsUpAppConsentMapping(res: any) {
  let result = {};
  if (res.RequestResult.Status.StatusCode == "1") {
    result = {
      status: true,
      msgID: res.RequestResult.RequestId,
      data: res.ContentData,
    };
  } else {
    result = {
      status: false,
      msgID: res.RequestResult.RequestId,
      data: {},
      error: `${errorMapper(res.RequestResult.Errors)}${msgOfErr(
        res.RequestResult.RequestId
      )}`,
    };
  }

  return result;
}

function generateKYCPdfMapping(res: any) {
  let result = {};
  if (res.RequestResult.Status.StatusCode == "1") {
    result = {
      status: true,
      msgID: res.RequestResult.RequestId,
      data: res.ContentData,
    };
  } else {
    result = {
      status: false,
      msgID: res.RequestResult.RequestId,
      data: {},
      error: `${errorMapper(res.RequestResult.Errors)}${msgOfErr(
        res.RequestResult.RequestId
      )}`,
      errMsg: "",
    };
  }

  return result;
}
function getIPVOTPMapping(res: any) {
  let result = {};
  if (res.RequestResult.Status.StatusCode == "1") {
    result = {
      status: true,
      msgID: res.RequestResult.RequestId,
      data: res.ContentData,
    };
  } else {
    result = {
      status: false,
      msgID: res.RequestResult.RequestId,
      data: {},
      error: `${errorMapper(res.RequestResult.Errors)}${msgOfErr(
        res.RequestResult.RequestId
      )}`,
    };
  }

  return result;
}

function getErrorBank(res: any) {
  let result = {};
  if (res.ProductId === "1") {
    result = {
      status: true,
      dataSource: res.DataSource,
    };
  } else {
    result = {
      status: false,
      data: {},
      error: `${errorMapper(res.RequestResult.Errors)}${msgOfErr(
        res.RequestResult.RequestId
      )}`,
    };
  }
}
function getDocumentAutoQcDetailsMapping(res: any) {
  let result = {};
  if (res.RequestResult.Status.StatusCode == "1") {
    result = {
      status: true,
      msgID: res.RequestResult.RequestId,
      data: res.ContentData,
    };
  } else {
    result = {
      status: false,
      msgID: res.RequestResult.RequestId,
      data: {},
      error: `${errorMapper(res.RequestResult.Errors)}${msgOfErr(
        res.RequestResult.RequestId
      )}`,
    };
  }

  return result;
}
function saveAreaMapping(res: any) {
  let result = {};
  if (res.RequestResult.Status.StatusCode == "1") {
    result = {
      status: true,
      msgID: res.RequestResult.RequestId,
      data: res.ContentData,
    };
  } else {
    result = {
      status: false,
      msgID: res.RequestResult.RequestId,
      data: {},
      error: `${errorMapper(res.RequestResult.Errors)}${msgOfErr(
        res.RequestResult.RequestId
      )}`,
    };
  }

  return result;
}
function saveAddressDetailsMapping(res: any) {
  let result = {};
  if (res.RequestResult.Status.StatusCode == "1") {
    result = {
      status: true,
      msgID: res.RequestResult.RequestId,
      data: res.ContentData,
    };
  } else {
    result = {
      status: false,
      msgID: res.RequestResult.RequestId,
      data: {},
      error: `${errorMapper(res.RequestResult.Errors)}${msgOfErr(
        res.RequestResult.RequestId
      )}`,
    };
  }

  return result;
}

function getCityByPincodeMapping(res: any) {
  let result = {};
  if (res.RequestResult.Status.StatusCode == "1") {
    result = {
      status: true,
      msgID: res.RequestResult.RequestId,
      data: res.ContentData,
    };
  } else {
    result = {
      status: false,
      msgID: res.RequestResult.RequestId,
      data: {},
      error: `${errorMapper(res.RequestResult.Errors)}${msgOfErr(
        res.RequestResult.RequestId
      )}`,
    };
  }
  return result;
}
function verifyDocumentDataMapping(res: any) {
  let result = {};
  if (res.RequestResult.Status.StatusCode == "1") {
    result = {
      status: true,
      msgID: res.RequestResult.RequestId,
      data: res.ContentData,
    };
  } else {
    result = {
      status: false,
      msgID: res.RequestResult.RequestId,
      data: {},
      error: `${errorMapper(res.RequestResult.Errors)}${msgOfErr(
        res.RequestResult.RequestId
      )}`,
    };
  }
  return result;
}
function getAddressDetailsMapping(res: any) {
  let result = {};
  if (res.RequestResult.Status.StatusCode == "1") {
    result = {
      status: true,
      msgID: res.RequestResult.RequestId,
      data: res.ContentData,
    };
  } else {
    result = {
      status: false,
      msgID: res.RequestResult.RequestId,
      data: {},
      error: `${errorMapper(res.RequestResult.Errors)}${msgOfErr(
        res.RequestResult.RequestId
      )}`,
    };
  }
  return result;
}

function checkLocationMapping(res: any) {
  let result = {};
  if (res.RequestResult.Status.StatusCode == "1") {
    result = {
      status: true,
      msgID: res.RequestResult.RequestId,
      data: res.ContentData,
    };
  } else {
    result = {
      status: false,
      msgID: res.RequestResult.RequestId,
      data: {},
      error: `${errorMapper(res.RequestResult.Errors)}${msgOfErr(
        res.RequestResult.RequestId
      )}`,
    };
  }
  return result;
}
function checkPhotoLivenessMapping(res: any) {
  let result = {};
  if (res.RequestResult.Status.StatusCode == "1") {
    result = {
      status: true,
      msgID: res.RequestResult.RequestId,
      data: res.ContentData,
    };
  } else {
    result = {
      status: false,
      msgID: res.RequestResult.RequestId,
      data: {},
      error: `${errorMapper(res.RequestResult.Errors)}${msgOfErr(
        res.RequestResult.RequestId
      )}`,
    };
  }
  return result;
}

function updatePanAddharLinkStatusMapping(res: any) {
  let result = {};
  if (res.RequestResult.Status.StatusCode == "1") {
    result = {
      status: true,
      msgID: res.RequestResult.RequestId,
      data: res.ContentData,
    };
  } else {
    result = {
      status: false,
      msgID: res.RequestResult.RequestId,
      data: {},
      error: `${errorMapper(res.RequestResult.Errors)}${msgOfErr(
        res.RequestResult.RequestId
      )}`,
    };
  }

  return result;
}

function createUCCRegCodeMapping(res: any) {
  let result = {};
  if (res.RequestResult.Status.StatusCode == "1") {
    result = {
      status: true,
      msgID: res.RequestResult.RequestId,
      data: res.ContentData,
    };
  } else {
    result = {
      status: false,
      msgID: res.RequestResult.RequestId,
      data: {},
      error: `${errorMapper(res.RequestResult.Errors)}${msgOfErr(
        res.RequestResult.RequestId
      )}`,
    };
  }

  return result;
}
